module.exports = __webpack_public_path__ + "img/HappyBeach.a48bfae4.jpg";